import { put, select, call, takeLeading } from 'typed-redux-saga'
import { Deserialize } from 'cerialize'
import { CityModel, citiesApi, citiesSelectors, CitiesNS, citiesSlice } from 'Pages/referenceBooks'
import { errorHandler, NOTIFICATION_TYPE, notifyMessageCreator, gridSlice } from 'Modules'
import { RequestParams } from 'Models'

function* getAll(action: CitiesNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(citiesSlice.actions.clearAll())
		}
		const data = yield* call(citiesApi.getAll, requestParams)
		data.entries = data.entries.map((item) => Deserialize(item, CityModel))

		if (!clear) {
			const oldData = yield* select(citiesSelectors.selectData)
			data.entries = [...oldData.entries, ...data.entries]
		}
		action.payload?.callback?.()
		yield* put(citiesSlice.actions.setRequestParams({ params: requestParams }))
		yield* put(citiesSlice.actions.getAllSuccess({ data }))
	} catch (error) {
		yield* call(errorHandler, error)
		yield* call(notifyMessageCreator, 'reference_books.cities.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* createOne(action: CitiesNS.CreateOne) {
	try {
		yield* call(citiesApi.createOne, action.payload.item)
		yield* put(citiesSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'reference_books.cities_create.success')
	} catch (error) {
		yield* call(errorHandler, error)
		yield* call(notifyMessageCreator, 'reference_books.cities_create.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

function* updateOne(action: CitiesNS.UpdateOne) {
	try {
		yield* call(citiesApi.updateOne, action.payload.item)
		yield* put(citiesSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'reference_books.cities_update.success')
	} catch (error) {
		yield* call(errorHandler, error)
		yield* call(notifyMessageCreator, 'reference_books.cities_update.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

function* deleteOne(action: CitiesNS.DeleteOne) {
	try {
		yield* call(citiesApi.deleteOne, action.payload.id)
		yield* put(citiesSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'reference_books.cities_delete.success')
	} catch (error) {
		yield* call(errorHandler, error)
		yield* call(notifyMessageCreator, 'reference_books.cities_delete.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

function* restoreOne(action: CitiesNS.RestoreOne) {
	try {
		yield* call(citiesApi.restoreOne, action.payload.id)
		yield* put(citiesSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'reference_books.cities_restore.success')
	} catch (error) {
		yield* call(errorHandler, error)
		yield* call(notifyMessageCreator, 'reference_books.cities_restore.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

export function* citiesSaga() {
	yield* takeLeading(citiesSlice.actions.getAll, getAll)
	yield* takeLeading(citiesSlice.actions.createOne, createOne)
	yield* takeLeading(citiesSlice.actions.updateOne, updateOne)
	yield* takeLeading(citiesSlice.actions.deleteOne, deleteOne)
	yield* takeLeading(citiesSlice.actions.restoreOne, restoreOne)
}
